import { Col, FormGroup, Label } from "reactstrap";
import UserListInEntity from "../../../../users/UserListInEntity";
import styles from "./index.module.scss";

const Participants = ({ participants, sessionId, ...props }) => {
    return (
        <Col className="px-2">
            <FormGroup className="mb-3 mt-3 mt-lg-0 templating-select select2-container">
                <Label className={styles.label}>Users Management</Label>
                <UserListInEntity
                    cards={participants}
                    entity={sessionId}
                    entityType="class"
                    {...props}
                />
            </FormGroup>
        </Col>
    );
};

export default Participants;